import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Fetch.module.css';
import d from '../FetchDesign.module.css';
import { useFetchDesign } from '../fetchDesign';
import { FetchTagIcon } from './FetchTagIcon';

export function FetchOfferBar() {
  const theme = useTheme();
  const design = useFetchDesign();

  if (design.layout === 'control') {
    return (
      <div className={styles.offerBar} style={theme.panelheaderNoneNone}>
        {design.offerLabel}
      </div>
    );
  }

  return (
    <div
      className={`${styles.offerBar} ${d.offerBarTagged}`}
      style={theme.panelheaderNoneNone}
    >
      <FetchTagIcon className={d.tagIcon} />
      <span>{design.offerLabel}</span>
    </div>
  );
}
